import { render, staticRenderFns } from "./Game10_ddp.vue?vue&type=template&id=09185137&scoped=true&"
import script from "./Game10_ddp.vue?vue&type=script&lang=js&"
export * from "./Game10_ddp.vue?vue&type=script&lang=js&"
import style0 from "./Game10_ddp.vue?vue&type=style&index=0&id=09185137&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09185137",
  null
  
)

export default component.exports